module.exports = __webpack_public_path__ + "static/media/yellow.9f5092ff.JPG";